import { CONFETTI_IMAGE_URL } from '../../../../../assets/deliveryDialogAssets';
import './Confetti.css';

type ConfettiProps = {
  className?: string;
};

/** Confetti PNG overlay — 1055×496. */
export function Confetti({ className }: ConfettiProps) {
  return (
    <img
      className={['confetti', className].filter(Boolean).join(' ')}
      src={CONFETTI_IMAGE_URL}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
